import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material";

const DataGridHeader = ({ headerName, children }) => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        overflow: "visible",
        flex: 1,
      }}
    >
      <Typography
        sx={{
          fontWeight: "bold",
          color: theme.palette.primary.main,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          flex: 1,
        }}
      >
        {headerName}
      </Typography>
      <Box
        sx={{
          flexShrink: 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default DataGridHeader;
